/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Email_ExistsInputs */

const en_team_manager_email_exists = /** @type {(inputs: Team_Manager_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email already exists in user group.`)
};

const fr_team_manager_email_exists = /** @type {(inputs: Team_Manager_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’e-mail existe déjà dans le groupe d’utilisateurs.`)
};

const de_team_manager_email_exists = /** @type {(inputs: Team_Manager_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die E-Mail-Adresse ist bereits in der Benutzergruppe vorhanden.`)
};

const it_team_manager_email_exists = /** @type {(inputs: Team_Manager_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'email esiste già nel gruppo utenti.`)
};

const ru_team_manager_email_exists = /** @type {(inputs: Team_Manager_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адрес электронной почты уже существует в группе пользователей.`)
};

const es_team_manager_email_exists = /** @type {(inputs: Team_Manager_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El correo electrónico ya existe en el grupo de usuarios.`)
};

const zh_cn2_team_manager_email_exists = /** @type {(inputs: Team_Manager_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户组中已存在该电子邮件地址。`)
};

const ja_team_manager_email_exists = /** @type {(inputs: Team_Manager_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザー グループに電子メールが既に存在します。`)
};

const hi_team_manager_email_exists = /** @type {(inputs: Team_Manager_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता समूह में ईमेल पहले से मौजूद है।`)
};

const pt_pt2_team_manager_email_exists = /** @type {(inputs: Team_Manager_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O e-mail já existe no grupo de usuários.`)
};

/**
* | output |
* | --- |
* | "Email already exists in user group." |
*
* @param {Team_Manager_Email_ExistsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_email_exists = /** @type {((inputs?: Team_Manager_Email_ExistsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Email_ExistsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_email_exists(inputs)
	if (locale === "de") return de_team_manager_email_exists(inputs)
	if (locale === "it") return it_team_manager_email_exists(inputs)
	if (locale === "ru") return ru_team_manager_email_exists(inputs)
	if (locale === "es") return es_team_manager_email_exists(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_email_exists(inputs)
	if (locale === "ja") return ja_team_manager_email_exists(inputs)
	if (locale === "hi") return hi_team_manager_email_exists(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_email_exists(inputs)
	return en_team_manager_email_exists(inputs)
});